import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { usePlaneViewOf } from '../usePlaneViewOf';
import LandmarkOverlay from './Landmark/LandmarkOverlay';

interface TileLandmarkMountProps {
    renderer: RenderAdapter;
    visible: boolean;
}

export default function TileLandmarkMount({
    renderer,
    visible,
}: TileLandmarkMountProps) {
    const view = usePlaneViewOf(renderer);
    if (!visible || !view) {
        return null;
    }
    return <LandmarkOverlay view={view} />;
}
